import * as actionTypes from "../actions";

const initialState = {
    form: actionTypes.getInitReservationForm(),

    currentReservation: {
        first_name: "",
        last_name: "",
        start_time: null,
        adults: 0,
        children: 0,
        token: "",
        comment: "",
        cake: false,
        highchair: false,
        stroller: false,
        reduced_mobility: false,
        terrace: false,
        event: "",
        custom_event: null,
        customer: null,
        cancelled: false,
        cancelled_by: null,
        cancelled_at: null,
        confirmed: false,
        confirmed_at: null,
        restaurant_cancel_message: ""
    },
    getCurrentReservationLoading: true,
    getCurrentReservationError: null,

    doesReservationExist: null,

    confirmReservationLoading: false,
    confirmReservationError: null,

    cancelReservationLoading: false,
    cancelReservationError: false,

    contactRestaurantLoading: false,
    contactRestaurantError: false,
};

const reservationReducer = (state = initialState, action) => {
    switch (action.type) {

        // CHANGE FORM
        case actionTypes.CHANGE_FORM:
            return {
                ...state,
                form: action.form
            };

        // RESET FORM
        case actionTypes.RESET_FORM:
            return {
                ...state,
                form: actionTypes.getInitReservationForm()
            };

        // CONFIRM RESERVATION
        case actionTypes.CONFIRM_RESERVATION_REQUEST:
            return {
                ...state,
                confirmReservationLoading: action.loading
            };
        case actionTypes.CONFIRM_RESERVATION_SUCCESS:
            return {
                ...state,
                confirmReservationLoading: action.loading,
                confirmReservationError: action.error,
            };
        case actionTypes.CONFIRM_RESERVATION_ERROR:
            return {
                ...state,
                confirmReservationLoading: action.loading,
                confirmReservationError: action.error
            };

        // CANCEL RESERVATION
        case actionTypes.CANCEL_RESERVATION_REQUEST:
            return {
                ...state,
                cancelReservationLoading: action.loading
            };
        case actionTypes.CANCEL_RESERVATION_SUCCESS:
            return {
                ...state,
                cancelReservationLoading: action.loading,
                cancelReservationError: action.error,
            };
        case actionTypes.CANCEL_RESERVATION_ERROR:
            return {
                ...state,
                cancelReservationLoading: action.loading,
                cancelReservationError: action.error
            };

        // CONTACT RESTAURANT
        case actionTypes.CONTACT_RESTAURANT_REQUEST:
            return {
                ...state,
                contactRestaurantLoading: action.loading
            };
        case actionTypes.CONTACT_RESTAURANT_SUCCESS:
            return {
                ...state,
                contactRestaurantLoading: action.loading,
                contactRestaurantError: action.error,
            };
        case actionTypes.CONTACT_RESTAURANT_ERROR:
            return {
                ...state,
                contactRestaurantLoading: action.loading,
                contactRestaurantError: action.error
            };

        // GET CURRENT RESERVATION
        case actionTypes.GET_CURRENT_RESERVATION_REQUEST:
            return {
                ...state,
                getCurrentReservationLoading: action.loading
            };
        case actionTypes.GET_CURRENT_RESERVATION_SUCCESS:
            return {
                ...state,
                getCurrentReservationLoading: action.loading,
                getCurrentReservationError: action.error,
                currentReservation: action.reservation,
                doesReservationExist: true
            };
        case actionTypes.GET_CURRENT_RESERVATION_ERROR:
            return {
                ...state,
                getCurrentReservationLoading: action.loading,
                getCurrentReservationError: action.error,
                doesReservationExist: false
            };

        default:
            return state;
    }
};

export default reservationReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/reservation.js